import { BaseReducer } from '@hobs/utils/baseReducer';
import { UPLOAD, SET, DELETE, CLEAR } from '@hobs/constants/attachment';
import Toast from '@hobs/components/Toast';

class Attachment extends BaseReducer {
  static defaultState = {
    attachments: []
  };

  constructor() {
    super(Attachment.defaultState);

    this.actionMap = {
      [UPLOAD.SUCCESS]: this.uploadAttachments,
      [UPLOAD.FAILURE]: this.displayError,
      [SET.SUCCESS]: this.setAttachments,
      [DELETE.SUCCESS]: this.deleteAttachment,
      [CLEAR.SUCCESS]: this.clearAttachments
    };
  }

  uploadAttachments = (state, action) => {
    return Object.assign({}, state, {
      attachments: [...state.attachments, ...action.response]
    });
  };

  displayError = (state, action) => {
    Toast.warning(action.error);
    return Object.assign({}, state, {
      attachments: [...state.attachments]
    });
  }

  setAttachments = (state, action) => {
    return Object.assign({}, state, { attachments: action.attachments });
  };

  deleteAttachment = (state, action) => {
    const filteredAttachments = state.attachments.filter(
      attachment => attachment.name !== action.file.name
    );

    return Object.assign({}, state, { attachments: filteredAttachments });
  };

  clearAttachments = state => {
    return Object.assign({}, state, { attachments: [] });
  };
}
export default new Attachment().reducer;
